import { render, staticRenderFns } from "./ShipmentType.vue?vue&type=template&id=174306d4&"
import script from "./ShipmentType.vue?vue&type=script&lang=js&"
export * from "./ShipmentType.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports